import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpEvent,
  HttpResponse,
  HttpRequest,
} from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { OpenReplayService } from '@app/services/open-replay/open-replay.service';

// This interceptor was created using the OpenReplay Angular SDK https://docs.openreplay.com/en/sdk/using-or/angular/
export const openReplayInterceptor: HttpInterceptorFn = (request, next) => {
  const openReplayService = inject(OpenReplayService);

  // This function will be called with the response a few lines below
  const handleResponse = (
    request: HttpRequest<any>,
    response: HttpResponse<any>,
    event: string,
  ) => {
    // We forward our data to the service, which will create the custom event and send it
    openReplayService.sendEventToReplaySession(event, { request, response });
  };

  return next(request).pipe(
    // Filter out events that aren't HTTP responses
    filter((event: HttpEvent<any>) => event instanceof HttpResponse),
    map((resp: HttpResponse<any>) => {
      // For each response, call handleResponse
      handleResponse(request, resp, `${request.url}`);
      return resp;
    }),
    map((event: HttpEvent<any>) => {
      return event;
    }),
  );
};
